import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { RolesView } from './components/rolesview';

const RolesPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Configuración',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Roles',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Roles</PageTitle>
      <RolesView/>
    </>
  );
};

export {RolesPage}